module.exports = __webpack_public_path__ + "img/SIS-HBLANCO.22f896f2.png";